import VxeOptgroupComponent from '../select/src/optgroup';
import { dynamicApp } from '../dynamics';
export var VxeOptgroup = Object.assign(VxeOptgroupComponent, {
    install: function (app) {
        app.component(VxeOptgroupComponent.name, VxeOptgroupComponent);
    }
});
export var Optgroup = VxeOptgroup;
dynamicApp.component(VxeOptgroupComponent.name, VxeOptgroupComponent);
export default VxeOptgroup;
